import moment from "moment";

const HelperPlugin = {
  install(Vue) {
    Vue.prototype.$debounce = (fn, delay) => {
      let timeout = null

      const debounced = function (...args) {
        const later = () => {
          timeout = null

          fn.apply(this, args)
        }

        clearTimeout(timeout)
        timeout = setTimeout(later, delay)

        if (!timeout) {
          fn.apply(this, args)
        }
      }

      debounced.cancel = () => {
        clearTimeout(timeout)
        timeout = null
      }

      return debounced
    }

    Vue.prototype.$orderBy = (objArr, key) => {
      return objArr.sort((a, b) => {
        let valA = null;
        let valB = null;

        if (key.includes('.')) {
          let [propA, propB] = key.split('.');
          valA = a[propA] && a[propA][propB] ? (typeof a[propA][propB] === 'string' ? a[propA][propB].toUpperCase() : a[propA][propB]) : null;
          valB = b[propA] && b[propA][propB] ? (typeof b[propA][propB] === 'string' ? b[propA][propB].toUpperCase() : b[propA][propB]) : null;
        } else {
          valA = a[key] ? a[key].toUpperCase() : null;
          valB = b[key] ? b[key].toUpperCase() : null;
        }

        let comparison = 0;
        if (valA > valB) {
          comparison = 1;
        } else if (valA < valB) {
          comparison = -1;
        }
        return comparison;
      })
    }

    Vue.filter('str_limit', (value, beginning, end) => {
      if (!value) return '';
      value = value.toString();
      beginning = beginning || 0;
      end = end || 0;

      if (value.length <= (beginning + end)) {
        return value;
      }
      let returns = '';
      returns += value.substr(0, beginning);
      returns += '*'.repeat(value.length - (beginning + end));
      returns += value.substr(value.length - end, value.length);

      return returns;
    })

    Vue.filter('title_case', (value) => {
      if (!value || typeof value !== 'string') return value

      return value
        .toLowerCase()
        .split(/[\s_]/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    })

    Vue.filter('lower_case', (value) => {
      if (!value || typeof value !== 'string') return value
      
      return value
        .toLowerCase();
    })

    Vue.filter('upper_case', (value) => {
      if (!value || typeof value !== 'string') return value

      return value
        .toUpperCase();
    })

    Vue.filter('date_only', (date) => {
      if (!date || date.length < 10) return date;
      return date.slice(0, 10);
    })

    Vue.filter('date_time', (dateTime) => {
      if (!dateTime || dateTime.length < 10) return dateTime;
      return moment(dateTime).format('YYYY-MM-DD HH:mm');
    })

    Vue.filter('currency', (number) => {
      if (!number || !number.length) return number;
      return parseFloat(number).toFixed(2);
    })

    Vue.filter('truncate', function (text, length, clamp) {
      text = text || '';
      clamp = clamp || '...';
      length = length || 30;

      if (typeof text !== 'string') text = text.toString();
      if (text.length <= length) return text;

      var tcText = text.slice(0, length - clamp.length);
      var last = tcText.length - 1;


      while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;

      // Fix for case when text dont have any `space`
      last = last || length - clamp.length;

      tcText = tcText.slice(0, last);

      return tcText + clamp;
    })
  }
}

export default HelperPlugin;